module.exports = __webpack_public_path__ + "img/fig30.1f4632c1.jpg";